import axios from 'axios';
import { toIsbn13 } from './util.to-isbn.js';

/**
 * Determines all the products that a given user is authorized to access.
 */
async function getAuthorizedProductsForUser(user) {
  const authorizedIsbnSet = new Set();

  // Determine all the products that the given user is authorized to access,
  // using either eKey or unic depending on provider.
  if (user.authenticationProvider === "ekey") {
    const {
      data: ekeyDetails
    } = await axios.get(`${process.env["NEXT_PUBLIC__GAS_API"]?.replaceAll("{{version}}", "v")}/api/User/GetEkeyUserDetailsByEmail?userEmail=${user.id}`);
    const {
      data
    } = await axios.get(`${process.env["NEXT_PUBLIC__GAS_API"]?.replaceAll("{{version}}", "v")}/api/License/GetProductLicensesByUser?ekeyUserId=${ekeyDetails.UserId}`);
    for (const element of data) {
      authorizedIsbnSet.add(toIsbn13(element.Product.Isbn));
    }
  } else {
    const {
      data: products
    } = await axios.get(`${process.env["NEXT_PUBLIC__GAS_API"]?.replaceAll("{{version}}", "v1")}/api/v1/Unic/Products/User/${user.id}`);
    for (const product of products) {
      authorizedIsbnSet.add(toIsbn13(product.Id));
    }
  }
  return authorizedIsbnSet;
}

export { getAuthorizedProductsForUser };
//# sourceMappingURL=api.get-authorized-products-for-user.js.map
